import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import fileDownload from 'js-file-download';
import moment from 'moment';
import {
  Button,
  Container,
  CardGroup,
  Jumbotron,
  Spinner,
} from 'react-bootstrap';
import { AppState } from '../store/config';
import {
  getAllTickets,
  getResolvedTicketsCsv,
} from '../state/actions/support/actions';
import { decodeToken } from '../utils/checkToken';
import TicketCard from '../components/TicketCard';
import { DashboardStyle, Footer, Loaders } from './styles/dashboard';
import Nav from '../components/Navbar';
import { AxiosResponse } from 'axios';
import DropdownUI from '../components/Dropdown';
import { Ticket } from '../state/actions/support/support.types';

type Props = ReturnType<typeof mapStateToProps> & any;
const RestrictedDashboard: React.FC<Props> = ({
  getAllTickets,
  getResolvedTicketsCsv,
  tickets,
  loading,
}) => {
  const user = decodeToken();
  const [val, setVal] = useState('');
  const [displayTickets, setTickets] = useState<Ticket[]>(tickets);

  const filteredCards = (val: any) => {
    const filteredTickets = tickets?.filter((ticket: Ticket) => {
      return val === 'ALL'
        ? ticket.status.includes('')
        : ticket.status.includes(val);
    });
    setTickets(filteredTickets);
  };

  useEffect(() => {
    getAllTickets();
    setTickets(tickets);
  }, [val]);

  const dateTime = moment().format('DD-MM-YYYY-hhmmss');

  const exportResolvedTickets = (
    e: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    e.preventDefault();
    getResolvedTicketsCsv().then((res: AxiosResponse) => {
      fileDownload(res.data, `${dateTime}.csv`);
    });
  };

  return (
    <>
      <DashboardStyle>
        <Nav />
        {loading ? (
          <Loaders>
            <Spinner animation="border" variant="primary" />
          </Loaders>
        ) : (
          <>
            <Jumbotron>
              <Container>
                <h3>Welcome {user!.username}!</h3>{' '}
                <p>Which tickets would you like to review?</p>
                <DropdownUI
                  val={val}
                  setVal={setVal}
                  filteredCards={filteredCards}
                />
              </Container>
            </Jumbotron>

            <Container className="section">
              <Button variant="link" onClick={(e) => exportResolvedTickets(e)}>
                Export Resolved Tickets in the Past Month
              </Button>
              <CardGroup>
                {tickets?.length > 0
                  ? displayTickets?.map((ticket: any, idx: number) => (
                      <TicketCard ticket={ticket} key={idx} />
                    ))
                  : "You don't have any tickets"}
              </CardGroup>
            </Container>
          </>
        )}
      </DashboardStyle>
      <Footer>
        <Container>
          {new Date().getFullYear()} &copy; Made with React Bootstrap
        </Container>
      </Footer>
    </>
  );
};

const mapStateToProps = ({ supportReducer }: AppState) => ({
  loading: supportReducer.loading,
  tickets: supportReducer.tickets,
  ticket: supportReducer.ticket,
  error: supportReducer.error,
});

export default connect(mapStateToProps, {
  getAllTickets,
  getResolvedTicketsCsv,
})(RestrictedDashboard);
